"use strict";
/*
 * WPSEO.AI
 *
 * @package       WPSEOAI
 * @author        WPSEO.AI Ltd
 * License:       MIT
 *
 * NOTE: This may be refactored, at a later date
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Toggle collapsable cards, on the WPSEO.AI dashboard
 */
const wpseoaiCardToggles = document.querySelectorAll('.toplevel_page_wpseoai_dashboard .card .toggle');
if (wpseoaiCardToggles !== null) {
    wpseoaiCardToggles.forEach((toggle) => {
        toggle.addEventListener('click', function (e) {
            var _a, _b;
            const state = toggle.getAttribute('aria-pressed') === 'true';
            toggle.setAttribute('aria-pressed', state ? 'false' : 'true');
            if (state)
                (_a = toggle.nextElementSibling) === null || _a === void 0 ? void 0 : _a.classList.remove('show');
            else
                (_b = toggle.nextElementSibling) === null || _b === void 0 ? void 0 : _b.classList.add('show');
        });
    });
}
/**
 *
 */
const wpseoaiRequest = document.querySelector('#wpseoai-request');
if (wpseoaiRequest !== null) {
    const p = document.createElement('p');
    p.innerText = 'Processing...';
    wpseoaiRequest.append(p);
    (() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        const controller = typeof AbortController === 'undefined' ? undefined : new AbortController();
        const type = wpseoaiRequest.getAttribute('data-type');
        // console.log(type);
        const post = wpseoaiRequest.getAttribute('data-post');
        // console.log(post);
        const nonceRequest = wpseoaiRequest.getAttribute('data-nonce-request');
        // console.log(nonceRetrieve);
        const nonceAudit = wpseoaiRequest.getAttribute('data-nonce-audit');
        // console.log(nonceAudit);
        const url = `${window.location.origin}/wp-json/wpseoai/v1/${type}?post=${post}`;
        // console.log(url);
        const tooLongTimeout = setTimeout(() => {
            const p = document.createElement('p');
            p.innerHTML = 'This is taking longer than it should. You can <a href="">refresh the page</a>, or try again later. If this problem persists, please <a href="https://wpseo.ai/" target="_blank">contact us</a>';
            wpseoaiRequest.append(p);
            controller === null || controller === void 0 ? void 0 : controller.abort();
        }, 6000);
        const response = yield fetch(url, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-WP-Nonce": nonceRequest
            },
            signal: controller === null || controller === void 0 ? void 0 : controller.signal,
        });
        const data = yield response.json();
        // console.log(data);
        clearTimeout(tooLongTimeout);
        // console.log(window.location);
        // console.log(response);
        const code = (_a = data === null || data === void 0 ? void 0 : data.code) !== null && _a !== void 0 ? _a : response.status;
        const message = (_b = data === null || data === void 0 ? void 0 : data.message) !== null && _b !== void 0 ? _b : response.statusText;
        const auditId = (_c = data === null || data === void 0 ? void 0 : data.auditId) !== null && _c !== void 0 ? _c : 0;
        const dashboardUrl = `${window.location.origin}/wp-admin/admin.php?page=wpseoai_dashboard`;
        // Error
        if (response.status > 200
            || (response.status === 200 && code === 204)) {
            const p = document.createElement('p');
            p.innerText = `Error: "${message}" (code ${code})`;
            wpseoaiRequest.append(p);
            const a = document.createElement('a');
            a.href = dashboardUrl;
            a.innerText = `Return to dashboard`;
            wpseoaiRequest.append(a);
            // console.error('Request error', response);
        }
        // Success
        else {
            const p = document.createElement('p');
            p.innerText = 'Success, redirecting...';
            wpseoaiRequest.append(p);
            // console.log('Request success', response);
            if (auditId) {
                window.location.href = `${dashboardUrl}&action=audit&post_id=${auditId}&_wpnonce=${nonceAudit}`;
            }
            else {
                window.location.href = dashboardUrl;
            }
        }
    }))();
}
